import { Link } from "@/lib/locale-link";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { track } from "@/lib/analytics";
import { useTranslation } from "@/hooks/useTranslation";
import { CONSUMER_JOIN_ROUTE } from "@/lib/homepage-ctas";

export function MobileStickyCta() {
  const { user } = useAuth();
  const { t } = useTranslation();
  if (user) return null;

  return (
    <div className="md:hidden fixed bottom-[calc(env(safe-area-inset-bottom)+72px)] inset-x-3 z-40 pointer-events-none">
      <Link
        to={CONSUMER_JOIN_ROUTE}
        onClick={() =>
          track("mobile_sticky_cta_clicked", {
            cta: "primary",
            intent: "consumer_join",
            destination: CONSUMER_JOIN_ROUTE,
            surface: "home_v2_mobile_sticky",
          })
        }
      >
        <Button
          size="lg"
          className="w-full h-12 font-medium shadow-2xl shadow-primary/30 backdrop-blur"
        >
          {t("mobileCta.stickyCta")}
        </Button>
      </Link>
    </div>
  );
}
